import "firebase/firestore";
import announcements from "@/frame/messages/mixins/announcements.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import btnControl from "@/frame/animation/mixins/btnControl.js";
import docRevsFunctions from "@/document/revisions/mixins/docRevsFunctions.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import generateLog from "@/document/log/mixins/generateLog.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import changeFirebase from "@/data/cloud/firebase/mixins/changeFirebase.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import generateRelps from "@/data/functions/mixins/generateRelps.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";
import relpsFunctions from "@/data/functions/mixins/relpsFunctions.js";
import workCallFunctions from "@/work/call/mixins/workCallFunctions.js";
import relps from "@/data/forms/mixins/relps.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import generateRoles from "@/support/roles/mixins/generateRoles.js";
import statsMods from "@/support/stats/mixins/statsMods.js";
import { mapGetters } from "vuex";

export default {
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUserAccessList",
      "getDocumentLog",
      "getOriginal",
      "getBudgetDID",
      "getMaterialDID",
      "getMaintStrategyDID",
      "getAssetRegister",
      "getSearchResults",
      "getSearchResultsCounter"
    ])
  },
  data() {
    return {
      dbEmpty: false,
      duplicate: false,
      searchLimitDuplicateCheck: 10000
    };
  },
  mixins: [
    relps,
    btnControl,
    dataSources,
    announcements,
    docRevsFunctions,
    docLogFunctions,
    accessFunctions,
    listFunctions,
    generateID,
    changeFirebase,
    describeDocument,
    displayFunctions,
    numberFunctions,
    apptheme,
    generateLog,
    generateRelps,
    statsFunctions,
    relpsFunctions,
    generateRoles,
    workCallFunctions,
    statsMods
  ],
  methods: {
    createFirebaseDocument(newDoc) {
      // DEFINE
      let duplicate = false;
      let tag = newDoc.basic.tag;
      let db = this.defineDataSourceFromTag(tag);
      let title = newDoc.basic.title;
      let id = newDoc.basic.id;
      // console.log("DUP. CHECK THEN CREATE DOC.");
      // console.log(tag);
      // console.log(db);
      // console.log(title);
      // console.log(newDoc);
      // eslint-disable-next-line
      db.limit(this.searchLimitDuplicateCheck).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            if (
              doc.data().basic.title === title ||
              doc.data().basic.id === id
            ) {
              duplicate = true;
            }
          });
        })
        .then(() => {
          if (duplicate === true) {
            this.generateInfoSnackbar("error", "Duplicate Record.");
            this.stopBtnSpinAll();
          } else {
            this.createFirebaseDocumentOnly(newDoc);
          }
        })
        .catch(error => {
          this.stopBtnSpinAll();
          console.log("Error getting documents: ", error);
        });
    },
    createFirebaseDocumentOnly(doc) {
      // database and address
      let did = doc.basic.did; // address
      let tag = doc.basic.tag;
      let db = this.defineDataSourceFromTag(tag);
      // HELP
      // console.log("");
      // console.log("CREATE FIREBASE DOCUMENT ONLY");
      // console.log("TAG:   " + tag);
      // console.log("DID:   " + did);
      // console.log("TITLE: " + doc.basic.title);
      // console.log(doc);

      // SAVE
      // eslint-disable-next-line
      db.doc(did).set(doc).then(() => {
          // NEW COMPANY
          if (tag === "C1") {
            let didAccess = this.generateDID("DATE", "G1");
            // ACCESS ADMIN
            // eslint-disable-next-line
            this.createFirebaseDocumentAccess(doc, "G1", "Z5", "C1", didAccess);
            // ACCESS USER
            // eslint-disable-next-line
            this.createFirebaseDocumentAccess(doc, "G1", "U1", "NEW C1", didAccess);

            // NEW FACILITY
          } else if (tag === "F1") {
            // FACILITY DID
            this.$store.dispatch("changeFacilityDID", doc.basic.did);
            // ensure did is common for access
            let didAccess = this.generateDID("DATE", "G1");
            // ACCESS FACILITY
            // eslint-disable-next-line
            this.createFirebaseDocumentAccess(doc, "G1", "F1", "U1", didAccess);
            // ACCESS USER
            // eslint-disable-next-line
            this.createFirebaseDocumentAccess(doc, "G1", "U1", "NEW F1", didAccess);

            // NEW ORDER
          } else if (tag === "Q1") {
            // MATERIAL ORDER
            // eslint-disable-next-line
            if (
              this.getMaterialDID !== null &&
              this.getMaterialDID !== undefined
            ) {
              this.createDocumentCopyToMaster(doc, "L1.Q1");
            }
            // BUDGET ORDER
            // eslint-disable-next-line
            if (
              this.getBudgetDID !== null &&
              this.getBudgetDID !== undefined
            ) {
              this.createDocumentCopyToMaster(doc, "B4.Q1");
            }
            // NEW PLAN
          } else if (tag === "M5") {
            // MATERIAL ORDER
            // eslint-disable-next-line
            if (
              this.getMaintStrategyDID !== null &&
              this.getMaintStrategyDID !== undefined
            ) {
              this.createDocumentCopyToMaster(doc, "M2.M5");
            }
          } else {
            // DO NOTHING
          }
        })
        .then(() => {
          // GENERATE STATS REMOTE
          this.createFirebaseDocumentStatsRemote(tag, did);
        })
        .then(() => {
          // GENERATE RELPS REMOTE
          if (this.enableRelpsRemote(tag)) {
            this.createFirebaseDocumentRelpsRemote(tag, did);
          }
        })
        .then(() => {
          // UPDATE USER STATS
          this.updateUserStatsNewDoc(doc);
        })
        .then(() => {
          // UPDATE COMPANY STATS (IF REQUIRED)
          this.updateCompanyStatsNewDoc(doc);
        })
        .then(() => {
          // UPDATE FACILITY STATS (IF REQUIRED)
          this.updateFacilityStatsNewDoc(doc);
        })
        .then(() => {
          // ADD to SERACH RESULTS
          this.addNewToSearchResults(doc);
        })
        .then(() => {
          // GENERATE USER LOG
          this.generateUserLog(doc, "was created.");
        })
        .then(() => {
          // GENERATE COMPANY LOG
          this.generateCompanyLog(doc, "was created.");
        })
        .then(() => {
          // GENERATE FACILITY LOG (IF REQUIRED)
          if (doc.basic.tag !== "O1" && doc.basic.tag !== "M7") {
            // when facility log is created then W2 is not generated for M Call.
            this.generateFacilityLog(doc, "was created.");
          }
        })
        .then(() => {
          // GENERATE ASSET LOG (IF REQUIRED)
          this.generateAssetLog(doc, "was created.");
        })
        .then(() => {
          // GENERATE WORK CALLS from M7
          // console.log("");
          // console.log("HERE >>>");
          if (doc.basic.tag === "M7") {
            let maintCall = doc;
            // console.log("");
            // console.log(" <<< GENERATE WORK CALLS LOOP >>> ");
            // console.log(maintCall);
            // GENERATE WORK CALL based on MAINTENNACE PLAN
            if (
              this.getAssetRegister !== null &&
              this.getAssetRegister !== undefined
            ) {
              let assetList = this.getAssetRegister;
              for (var i = 0; i < this.getAssetRegister.length; i++) {
                // eslint-disable-next-line
                let workCall = this.generateWorkCallDocument(maintCall, i, assetList[i]);
                // database and address
                let did = workCall.basic.did; // address
                let db = this.defineDataSourceFromTag("W2");
                // eslint-disable-next-line
                db.doc(did).set(workCall).then(() => {
                    this.createFirebaseDocumentRelpsRemote("W2", did);
                  });
                // this.createFirebaseDocumentOnly(workCall);
              }
            }
            // FACILITY LOG;
            this.generateFacilityLog(doc, "was created.");
          }
        })
        .then(() => {
          // SNACK BAR
          if (tag !== "W2") {
            let tagMsg = doc.basic.tag;
            let msg = "New ";
            msg = msg + this.defineDocumentFromTag(tagMsg).title;
            msg = msg + " ";
            msg = msg + this.displayDocumentIDGTypeA(tag, doc.basic.idg) + " ";
            msg = msg + doc.basic.title + " ";
            msg = msg + "was created.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
            // STOP BTN SPIN
            this.stopBtnSpinAll();
            // CLOSE
            this.dialog = false;
          }
        })
        // eslint-disable-next-line
        .catch((error) => {
          this.stopBtnSpinAll();
          // eslint-disable-next-line
          // this error somtimes pop up when new doc is saved.
          // this.generateInfoSnackbar("error", "new document upload failed !!!");
          this.generateInfoSnackbar("warning", "Network latency issue.");
          this.dialog = false;
          // console.log("");
          // console.log("CATCH ERROR - CREATE FIRBASE");
          // console.log(error);
        });
    },
    createFirebaseDocumentRelpsPreloaded(doc, type, data) {
      // database and address
      let did = doc.basic.did; // address
      let tag = doc.basic.tag;
      let db = this.defineDataSourceFromTag(tag);
      // HELP
      // console.log("");
      // console.log("CREATE FIREBASE DOCUMENT ONLY with RELPS PRELOADED");
      // console.log("TAG:   " + tag);
      // console.log("DID:   " + did);
      // console.log("TITLE: " + doc.basic.title);
      // console.log(doc);

      // SAVE
      // eslint-disable-next-line
      db.doc(did).set(doc).then(() => {
          // GENERATE RELPS REMOTE
          this.createFirebaseDocumentRelpsRemotePreloaded(tag, did, type, data);
        })
        // eslint-disable-next-line
        .catch((error) => {
          this.stopBtnSpinAll();
          // eslint-disable-next-line
          // this error somtimes pop up when new doc is saved.
          // this.generateInfoSnackbar("error", "new document upload failed !!!");
          this.generateInfoSnackbar("warning", "Network latency issue.");
          this.dialog = false;
          // console.log("");
          // console.log("CATCH ERROR - CREATE FIRBASE");
          // console.log(error);
        });
    },
    addNewToSearchResults(item) {
      // DEFINE
      let tag = item.basic.tag;
      let temp = item;
      temp.basic.list = true; // recently accessed idnicator
      temp.basic.save = true; // save availablke
      // UPDATE EMEDDED LIST which if the list is ACTIVE
      // eslint-disable-next-line
      if (this.getSearchResults !== null && this.getSearchResults !== undefined) {
        if (this.getSearchResults.length > 0) {
          let tagResult = this.getSearchResults[0].basic.tag;
          if (tagResult === tag) {
            // LIST UPDATE
            var tempList = this.getSearchResults;
            var obj = Object.assign({}, temp);
            var parseobj = JSON.parse(JSON.stringify(obj));
            var newList = this.addItemReturnListCheckDID(parseobj, tempList);
            // var newList = tempList.push(obj);
            this.$store.dispatch("changeSearchResults", newList);
            // eslint-disable-next-line
            this.$store.dispatch("changeSearchResultsCounter", this.getSearchResultsCounter + 1);

            // console.log(newList);
            this.dialog = false;
            this.stopBtnSpinAll();
            // UPDATE LIST
            // console.log("");
            // console.log(">>> SEARCH RESULTS NEW ITEM ADDED <<<");
            // console.log(tag);
            // console.log(temp);
            // console.log(newList);
          }
        }
      }
    },
    createFirebaseDocumentStatsRemote(tag, did) {
      // DEFINE
      let db = this.defineDataSourceFromTag("G5");
      let stats = this.defineStatsRemote(tag);
      // CREATE STATS REMOTE for SOME DOCs ONLY
      if (this.enableStatsRemote(tag) === true) {
        // HELP
        // console.log("CREATE FIREBASE STATS REMOTE");
        // console.log(db);
        // console.log(tag);
        // console.log(did);
        // console.log(stats);
        // console.log(this.enableStatsRemote(tag));
        // eslint-disable-next-line
        db.doc(did).set(stats).then(() => {}).catch(() => {
            let msg = "remote stats upload failed";
            this.generateInfoSnackbar("error", msg);
          });
      }
    },
    createFirebaseDocumentRelpsRemote(tag, did) {
      // console.log(" >>> CREATE FIREBASE RELPS REMOTE NOW <<<");
      // DEFINE
      let db = this.defineDataSourceFromTag("G6");
      let relps = this.defineRelps(tag);
      // ROLES - INITIAL
      if (tag !== undefined && tag !== "E8") {
        relps.g4 = this.generateInitialRoles(tag);
      }
      // CREATE RELPS REMOTE (NO CHECK - APPLY to ALL DOCs)
      if (tag !== undefined && this.enableRelpsRemote(tag) === true) {
        if (tag === "W2") {
          relps = this.generateWorkCallRelps();
        }
        // HELP
        // console.log("");
        // console.log(" >>> CREATE FIREBASE RELPS REMOTE <<<");
        // console.log("ENABLE RELPS" + this.enableRelpsRemote(tag));
        // console.log("TAG " + tag);
        // console.log("DID " + did);
        // console.log("DB");
        // console.log(db);
        // console.log("RELPS");
        // console.log(relps);
        // console.log("ROLES");
        // console.log(this.generateInitialRoles(tag));
        // eslint-disable-next-line
        db.doc(did).set(relps).then(() => {}).catch(() => {
            let msg = "remote relationships upload failed";
            this.generateInfoSnackbar("error", msg);
          });
      }
    },
    createFirebaseDocumentRelpsRemotePreloaded(tag, did, type, data) {
      // DEFINE
      let db = this.defineDataSourceFromTag("G6");
      let relps = this.defineRelps(tag);
      // ROLES - INITIAL
      if (tag !== undefined && tag !== "E8") {
        relps.g4 = this.generateInitialRoles(tag);
      }
      if (type === "E5" || type === "e5") {
        relps.e5 = data;
      }
      // CREATE RELPS REMOTE (NO CHECK - APPLY to ALL DOCs)
      if (tag !== undefined && this.enableRelpsRemote(tag) === true) {
        // HELP
        // console.log("");
        // console.log(" >>> CREATE FIREBASE RELPS REMOTE [PRELOADED] <<<");
        // console.log("ENABLE " + this.enableRelpsRemote(tag));
        // console.log("TAG    " + tag);
        // console.log("DID    " + did);
        // console.log("DB");
        // console.log(db);
        // console.log("RELPS");
        // console.log(relps);
        // console.log("ROLES");
        // console.log(this.generateInitialRoles(tag));
        // eslint-disable-next-line
        db.doc(did).set(relps).then(() => {}).catch(() => {
            let msg = "remote relationships upload failed";
            this.generateInfoSnackbar("error", msg);
          });
      }
    },
    generateInitialRoles(tag) {
      let roles = [];
      if (
        tag === "C1" ||
        tag === "B1" ||
        tag === "E1" ||
        tag === "E6" ||
        tag === "S1" ||
        tag === "W6"
      ) {
        roles = this.generateSingleRole(tag);
      }
      if (tag === "B3" || tag === "B4" || tag === "B6" || tag === "Q1") {
        roles = this.generateTwoRoles(tag);
      }
      // eslint-disable-next-line
      if (tag === "E2" || tag === "F1" || tag === "M2" || tag === "M5" || tag === "S6") {
        roles = this.generateThreeRoles(tag);
      }
      return roles;
    },
    createFirebaseDocumentAccess(doc, tag, tagd, tags, did) {
      // define database
      let db = this.defineDataSourceFromTagForRelationship(tag, tagd);
      let temp = this.generateAccess(doc, tagd, tags, did);

      // HELP
      // console.log("");
      // console.log(">>> GENERATE DOCUMENT ACCESS <<<");
      // console.log(tag + " / " + tagd + " / " + tags);
      // console.log(did);
      // console.log(db);
      // console.log(doc);
      // console.log(temp);

      // SAVE
      // eslint-disable-next-line
      db.doc(did).set(temp).then(() => {
          // SAVE STORE
          if (tagd == "U1") {
            let userAccessList = this.getUserAccessList;
            // eslint-disable-next-line
            let duplicate = this.checkUserAccessDuplicate(temp.char.did, userAccessList);
            if (duplicate === false) {
              userAccessList.push(temp);
              this.$store.dispatch("changeUserAccessList", userAccessList);
            }
          }
        })
        // eslint-disable-next-line
        .catch((error) => {
          this.stopBtnSpinAll();
          // eslint-disable-next-line
          this.generateInfoSnackbar("error", "new data upload failed");
          console.log(error);
        });
    },
    createFirebaseDocumentLog(tag, log) {
      // define database
      let db = this.defineDataSourceFromTagForRelationship("D3", tag);
      let temp = log;
      let did = temp.basic.did;
      // HELP
      // console.log("");
      // console.log(">>> FIREBASE CREATE DOCUMENT LOG <<<");
      // console.log("TAG : " + tag);
      // console.log("LOG : " + log);
      // console.log("DID : " + did);
      // console.log(db);
      // console.log(temp);

      // SAVE
      // eslint-disable-next-line
      db.doc(did).set(temp).then(() => {
          // Create Change Tracker
          this.stopBtnSpinAll();
          this.dialog = false;
        })
        // eslint-disable-next-line
        .catch((error) => {
          this.stopBtnSpinAll();
          // eslint-disable-next-line
          this.generateInfoSnackbar("error", "new data upload failed");
          console.log(error);
        });
    },
    createDocumentCopyToMaster(detail, tag) {
      let did = detail.basic.did;
      let db = this.defineDataSourceFromTag(tag);
      // console.log(db);
      // console.log("");
      // console.log(">>> APPEND DOCUMENT TO MASTER  <<<");
      // console.log("MASTER TAG " + tag);
      // console.log("MASTER DID " + did);
      // console.log("DOC    TAG " + detail.basic.tag);
      // console.log("DOC    DID " + detail.basic.did);
      // console.log(db);
      // eslint-disable-next-line
      db.doc(did).set(detail).then(() => {
          this.btnSpinAppendToMaster = false;
          // MESSAGE
          if (tag === "B6.W") {
            let msg = "Plan ";
            msg = msg + detail.link.pt;
            msg = msg + " was updated with new Work ";
            // eslint-disable-next-line
            msg = msg + this.displayDocumentIDGTypeA(detail.basic.tag, detail.basic.idg) + ".";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
            // UPDATE
          }
        });
    },
    createFirebaseDocumentChangeTracker(u) {
      // db = database, add = address
      let db = this.dbDocumentChangeTracker;
      let k = this.generateChangeTracker(u);
      // HELP
      // console.log("creatFirebase.js");
      // console.log("createFirebaseDocumentThenChangeTracker");
      // console.log(k);
      // db.collection(k.idm).doc(k.did).set(k).then(() => {
      //     // this.stopBtnSpinAll();
      //     // this.dialog = false;
      //     // this.generateInfoSnackbar("success", m);
      //   })
      // eslint-disable-next-line
      db.doc(u.basic.did).collection("tracker").doc(k.did).set(k).then(() => {
          // this.stopBtnSpinAll();
          // this.dialog = false;
          // this.generateInfoSnackbar("success", m);
        })
        // eslint-disable-next-line
        .catch((error) => {
          this.stopBtnSpinAll();
          this.generateInfoSnackbar("error", "change tracker upload failed");
          // eslint-disable-next-line
          return false;
        });
    }
  }
};
